import React from 'react';
import {
  FormPageInputItemDate,
  FormPageInputItemDateFree,
  DateProperty,
  DatePropertyFree,
  DATE_PROPERTY_INPUT_TYPE,
  DatePropertyYearPulldown,
  FormPageInputItemDateYearPulldown,
} from 'shared';
import { FormFieldInputProps, hasErrorMessage } from '../shared';
import { DateFree } from './DateFree';
import { DateYearPulldown } from './DateYearPulldown';

export type DateInputProps = FormFieldInputProps<
  DateProperty,
  FormPageInputItemDate
>;

const isError = (
  errorMessages: DateInputProps['errorMessages'],
  displayError = false,
): boolean => !!displayError && hasErrorMessage(errorMessages);

export const DateInput: React.FC<DateInputProps> = (props) => {
  switch (props.property.inputFormat.inputType) {
    case DATE_PROPERTY_INPUT_TYPE.free: {
      const { submitted, touched, errorMessages, value, ...baseProps } =
        props as FormFieldInputProps<
          DatePropertyFree,
          FormPageInputItemDateFree
        >;
      const displayError =
        submitted || (touched && touched.year && touched.month && touched.day);
      return (
        <DateFree
          yearValue={value.year}
          monthValue={value.month}
          dayValue={value.day}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
    case DATE_PROPERTY_INPUT_TYPE.yearPulldown: {
      const { submitted, touched, errorMessages, value, ...baseProps } =
        props as FormFieldInputProps<
          DatePropertyYearPulldown,
          FormPageInputItemDateYearPulldown
        >;
      const displayError =
        submitted || (touched && touched.year && touched.month && touched.day);
      return (
        <DateYearPulldown
          yearValue={value.year}
          monthValue={value.month}
          dayValue={value.day}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
  }
};
